import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetPublicWorkHistoryLayerListRequest,
	IPayloadGetPublicWorkHistoryLayerListSuccess,
	IPublicWorkHistoryLayerDetailStore,
} from './public-work-history-layer.type';

const initialState = {
	fetching: false,
	publicWorkHistoryLayerList: [] as IPublicWorkHistoryLayerDetailStore[],
};

const publicWorkHistoryLayerSlice = createSlice({
	initialState,
	name: 'publicWorkHistoryLayer',
	reducers: {
		/**---- GET PUBLIC_WORK_HISTORY_LAYER LIST START ---- */
		getPublicWorkHistoryLayerListRequest: (
			state,
			_action: PayloadAction<IPayloadGetPublicWorkHistoryLayerListRequest>
		) => {
			state.fetching = true;
		},
		getPublicWorkHistoryLayerListSuccess: (
			state,
			action: PayloadAction<IPayloadGetPublicWorkHistoryLayerListSuccess>
		) => {
			const { content } = action.payload;
			state.fetching = false;
			state.publicWorkHistoryLayerList = content;
		},
		getPublicWorkHistoryLayerListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET PUBLIC_WORK_HISTORY_LAYER LIST END ---- */
	},
});

export const PublicWorkHistoryLayerSelectors = {
	selectFetching: (state: RootState) => state.publicWorkHistoryLayer.fetching,
	selectList: (state: RootState) =>
		state.publicWorkHistoryLayer.publicWorkHistoryLayerList,
};

export const PublicWorkHistoryLayerActions =
	publicWorkHistoryLayerSlice.actions;
export const PublicWorkHistoryLayerReducer =
	publicWorkHistoryLayerSlice.reducer;
